<!--<app-main-page></app-main-page>-->
<router-outlet></router-outlet>
<!--<app-indication-main></app-indication-main>-->
